import React from 'react';
import { getRecordData } from 'utils/tools';
import FormGoogleAutocomplete, {
  FormGoogleAutocompleteProps,
} from '../../form/FormGoogleAutocomplete';
import { RestInputContext } from '../RestInputContext';

const RestFormInput = (props: FormGoogleAutocompleteProps) => (
  <RestInputContext.Consumer>
    {({ record, form }) => (
      <FormGoogleAutocomplete
        {...props}
        record={record}
        form={form}
        defaultValue={getRecordData(record, props.source)}
      />
    )}
  </RestInputContext.Consumer>
);

export default RestFormInput;
